module.exports = __webpack_public_path__ + "img/Netherlands.ccd6451f.svg";